import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../services/ApiService'
import { removeCookies } from '../../utility/Cookies'
import { showAlert } from '../../utility/SweetAlert'

const InteractorReturnCreate = () => {
  const { t } = useTranslation()
  const returnCreate = useCallback(
    (payload, loading) => {
      ApiService.jsonRequest('/transaction-retur-header/create', payload, (response) => {
        let res_return = response.messages

        if (response.status_code === 200) {
          removeCookies('summary-header')
          showAlert({
            icon: 'success',
            message: t('response_message.return_success'),
            timer: 2000,
            redirect: '/return',
          })
        } else {
          showAlert({
            icon: 'warning',
            message: t(`response_message.${res_return}`),
          })
        }
        loading(false)
      })
    },
    [t],
  )
  return { returnCreate }
}

export default InteractorReturnCreate
